var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9375 2H7.0625C4.26656 2 2 4.32812 2 7.2V48.8C2 51.6719 4.26656 54 7.0625 54H23.9375C26.7334 54 29 51.6719 29 48.8V7.2C29 4.32812 26.7334 2 23.9375 2Z",
    stroke: "#767676",
    strokeWidth: 2.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H12.35C12.4693 4 12.5838 4 12.6682 4C12.7526 4 12.8 4 12.8 4C12.8 4 12.8948 4 13.0636 4C13.2324 4 13.4613 4 13.7 4H17.3C17.5387 4 17.7676 4 17.9364 4C18.1052 4 18.2 4 18.2 4C18.2 4 18.2474 4 18.3318 4C18.4162 4 18.5307 4 18.65 4H20",
    stroke: "#767676",
    strokeWidth: 2.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceShape);
export default __webpack_public_path__ + "static/media/deviceShape.b11f55141b0b3e37ec26b104356fd043.svg";
export { ForwardRef as ReactComponent };